import { Pet } from "yummypets-js-core";

export function isPetDataFullfilled(pet: Pet): boolean {
    return !!pet.bornDate
}